/* Pehro Dual: theme behaviour. No framework, no build step.
   Prices are never written from JavaScript: every money value is re-rendered by Liquid
   through the Section Rendering API so the shop's money format (and the currency app that
   rewrites it) keeps working. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- header: drawer + search ---------- */
  function initHeader() {
    var drawer = $('[data-jdrawer]');
    if (drawer) {
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-jdrawer-open]');
        var close = e.target.closest('[data-jdrawer-close]');
        if (open) { drawer.classList.add('open'); document.body.classList.add('jdrawer-open'); document.body.style.overflow = 'hidden'; var first = $('a, button', drawer); if (first) first.focus(); }
        if (close) { drawer.classList.remove('open'); document.body.classList.remove('jdrawer-open'); document.body.style.overflow = ''; }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('open')) { drawer.classList.remove('open'); document.body.classList.remove('jdrawer-open'); document.body.style.overflow = ''; }
      });
    }
    var searchbar = $('[data-searchbar]');
    if (searchbar) {
      $$('[data-search-toggle]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = searchbar.classList.toggle('open');
          b.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (isOpen) { var i = $('input', searchbar); if (i) i.focus(); }
        });
      });
    }
  }

  /* ---------- cart count in the header ---------- */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  /* ---------- tabs (policies) ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[role="tabpanel"]', root);
      function activate(i) {
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        panels.forEach(function (p, k) { if (k === i) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); } });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { activate(i); });
        t.addEventListener('keydown', function (e) {
          var n = i;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { n = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { n = (i - 1 + tabs.length) % tabs.length; }
          if (n !== i) { e.preventDefault(); activate(n); tabs[n].focus(); }
        });
      });
      var initial = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      activate(initial < 0 ? 0 : initial);
    });
  }

  /* ---------- product gallery dots (mobile) ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var figures = $$('figure', g);
      var box = g.closest('[data-gallery-box]') || g.parentNode;
      var dots = $('[data-gallery-dots]', box);
      if (!dots || figures.length < 2) return;
      dots.innerHTML = figures.map(function (f, i) {
        return '<button type="button" aria-label="Image ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '></button>';
      }).join('');
      var buttons = $$('button', dots);
      var prev = $('[data-gallery-prev]', box), next = $('[data-gallery-next]', box), count = $('[data-gallery-count]', box);
      var strip = $('[data-gallery-thumbs]', box);
      var thumbs = strip ? $$('[data-gallery-to]', strip) : [];
      var cur = 0;
      function goTo(i) {
        i = Math.max(0, Math.min(figures.length - 1, i));
        g.scrollTo({ left: figures[i].offsetLeft - g.offsetLeft, behavior: 'smooth' });
      }
      buttons.forEach(function (b, i) { b.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
      if (next) next.addEventListener('click', function () { goTo(cur + 1); });
      function paint() {
        buttons.forEach(function (b, k) { if (k === cur) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); } });
        if (count) count.textContent = (cur + 1) + ' / ' + figures.length;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
        var on = thumbs[cur];
        if (on && strip) {
          var left = on.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft || left + on.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: left - 10, behavior: 'smooth' });
        }
        if (prev) prev.disabled = cur === 0;
        if (next) next.disabled = cur === figures.length - 1;
      }
      var ticking = false;
      g.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var x = g.scrollLeft, best = 0, bd = Infinity;
          figures.forEach(function (f, k) { var d = Math.abs((f.offsetLeft - g.offsetLeft) - x); if (d < bd) { bd = d; best = k; } });
          cur = best; paint();
          ticking = false;
        });
      }, { passive: true });
      paint();
    });
  }

  /* ---------- product form: variants, quantity, add to cart ---------- */
  function initProduct() {
    $$('[data-product-form]').forEach(function (form) {
      var select = $('select[name="id"]', form);
      var sectionId = form.getAttribute('data-section');
      var url = form.getAttribute('data-url');
      var fieldsets = $$('[data-option]', form);
      var busy = false;

      function selectedValues() {
        return fieldsets.map(function (f) {
          var c = $('input:checked', f) || $('select', f); /* pdp-2026-10-13: ring sizes are a select */
          return c ? c.value : '';
        });
      }

      function findVariant() {
        var key = selectedValues().join(' / ');
        var opts = $$('option', select);
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].getAttribute('data-opts') === key) return opts[i];
        }
        return null;
      }

      function refresh() {
        fieldsets.forEach(function (f) {
          var c = $('input:checked', f) || $('select', f), lbl = $('[data-selected]', f);
          if (c && lbl) lbl.textContent = c.value;
        });
        var opt = findVariant();
        if (!opt) { return; }
        select.value = opt.value;
        var id = opt.value;
        if (window.history && history.replaceState) {
          var q = new URLSearchParams(location.search); q.set('variant', id);
          history.replaceState(null, '', location.pathname + '?' + q.toString());
        }
        var media = opt.getAttribute('data-media');
        if (media) {
          var fig = $('[data-media-id="' + media + '"]');
          if (fig) fig.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        fetch(url + '?variant=' + id + '&section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            ['price', 'buy', 'sku', 'sticky-price'].forEach(function (k) {
              var src = $('[data-dyn="' + k + '"]', doc), dst = $('[data-dyn="' + k + '"]');
              if (src && dst) dst.innerHTML = src.innerHTML;
            });
          })
          .catch(function () {});
      }

      fieldsets.forEach(function (f) { f.addEventListener('change', refresh); });

      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-qty]');
        if (!b) return;
        e.preventDefault();
        var input = $('input[name="quantity"]', form);
        var v = parseInt(input.value, 10) || 1;
        v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });

      form.addEventListener('submit', function (e) {
        if (!window.fetch || busy) return;
        e.preventDefault();
        var btn = $('[data-add]', form);
        if (!btn || btn.disabled) return;
        busy = true;
        var label = btn.textContent;
        btn.textContent = 'Adding';
        var fd = new FormData(form);
        fetch(window.PD.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { throw new Error(res.j && res.j.description ? res.j.description : 'Could not add to bag'); }
            return fetch(window.PD.routes.cart + '.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            setCartCount(cart.item_count);
            btn.innerHTML = 'Added. <u>View bag</u>';
            btn.setAttribute('data-added', '1');
            btn.addEventListener('click', function go(ev) { if (btn.getAttribute('data-added')) { ev.preventDefault(); location.href = window.PD.routes.cart; } btn.removeEventListener('click', go); });
            setTimeout(function () { btn.textContent = label; btn.removeAttribute('data-added'); busy = false; }, 4000);
          })
          .catch(function (err) {
            btn.textContent = err.message || 'Could not add to bag';
            setTimeout(function () { btn.textContent = label; busy = false; }, 3000);
          });
      });
    });

    /* sticky add-to-bag strip on phones */
    var sticky = $('[data-sticky-cta]');
    var buy = $('[data-buy-anchor] [data-add]') || $('[data-buy-anchor]'); /* watch the button, not the whole column */
    if (sticky && buy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.classList.toggle('show', !visible);
        document.documentElement.classList.toggle('has-sticky-cta', !visible);
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(buy);
      sticky.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sticky-go]');
        if (b) { e.preventDefault(); buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    }
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var u = window.PD.routes.recommendations + '?section_id=' + el.getAttribute('data-section') + '&product_id=' + el.getAttribute('data-product') + '&limit=' + (el.getAttribute('data-limit') || 4);
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = $('[data-recommendations]', doc);
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; el.removeAttribute('hidden'); }
      }).catch(function () {});
    });
  }

  /* ---------- cart page ---------- */
  function initCart() {
    var root = $('[data-cart-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-section');

    function rerender() {
      return fetch(window.PD.routes.cart + '?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-section]', doc);
          if (fresh) { root.innerHTML = fresh.innerHTML; }
          root.classList.remove('cart-busy');
        });
    }

    function change(line, qty) {
      root.classList.add('cart-busy');
      return fetch(window.PD.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (cart) { setCartCount(cart.item_count); return rerender(); })
        .catch(function (err) {
          root.classList.remove('cart-busy');
          var box = $('[data-cart-msg]', root);
          if (!box) { box = document.createElement('p'); box.setAttribute('data-cart-msg', ''); box.setAttribute('role', 'alert'); box.className = 'cart-msg'; root.insertBefore(box, root.firstChild); }
          box.textContent = (err && (err.description || err.message)) || 'That change could not be made. Please try again.';
        });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line-qty]');
      var rm = e.target.closest('[data-line-remove]');
      if (b) {
        e.preventDefault();
        var item = b.closest('[data-line]');
        var input = $('input[data-line-input]', item);
        var v = parseInt(input.value, 10) || 0;
        v = b.getAttribute('data-line-qty') === '+' ? v + 1 : Math.max(0, v - 1);
        change(parseInt(item.getAttribute('data-line'), 10), v);
      }
      if (rm) {
        e.preventDefault();
        change(parseInt(rm.closest('[data-line]').getAttribute('data-line'), 10), 0);
      }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-line-input]');
      if (!input) return;
      var item = input.closest('[data-line]');
      change(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    var note = $('textarea[name="note"]', root);
    if (note) {
      var t;
      note.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          fetch(window.PD.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
        }, 600);
      });
    }
  }

  /* ---------- collection: filters toggle + sort ---------- */
  function initCollection() {
    var toggle = $('[data-filters-toggle]');
    var filters = $('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        var open = filters.classList.toggle('open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    var sort = $('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var q = new URLSearchParams(location.search);
        q.set('sort_by', sort.value);
        q.delete('page');
        location.search = q.toString();
      });
    }
    var form = $('[data-filter-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') { form.submit(); }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initTabs();
    initGallery();
    initProduct();
    initRecommendations();
    initCart();
    initCollection();
  });

  /* Theme editor: re-run initialisers when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function () {
    initTabs(); initGallery(); initProduct(); initRecommendations(); initCart(); initCollection();
  });
})();
